import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';
import { NewsletterType } from '../model/NewsletterType';
import { CacheService } from '../../shared/services/cache.service';

@Injectable()
export class NewsletterTypesService {
  private newsletterTypesApiURL = APP_SETTINGS.NewsletterTypesApiUrl;

  constructor(private executeService: ExecuteService,
    private cacheService: CacheService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetNewsletterTypes(): Observable<NewsletterType[]> {
    const url = this.newsletterTypesApiURL;

    return this.cacheService.get('getNewsletterTypes', this.executeService.Execute('get', url)
      .pipe(
        map(response => this.mapNewsletterTypeModels(response)),
        catchError(this.errorHandler.handleError<object[]>('NewsletterTypesService_GetNewsletterTypes', []))
      ));
  }

  private mapNewsletterTypeModels(nts: any[]): any {
    return nts.map(nt => ({
      NewsletterId: nt.id,
      Name: nt.name
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/users/services/newsletterTypes.service.ts